import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// Sentry.init() lives in App.jsx (the more complete config — includes
// session-replay + browser tracing integrations) and runs first via module
// evaluation order anyway (this file's `import App` is hoisted above the
// rest of this file's own top-level code). A second, simpler init used to
// live here too and silently overwrote the fuller config on every load.

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
